import { DocumentType } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity('documents_list')
export class DocumentsList {
    @PrimaryGeneratedColumn("increment", { name: 'documents_list_id' })
    documentsListId: number;

    @Column("int", {
        nullable: false,
        name: "sale_order_id"
    })
    saleOrderId: number;

    
    @Column("varchar", {
        nullable: true,
        name: "document_category",
    })
    documentCategory: string;

    @Column("varchar", {
        nullable: true,
        name: "file_name",
    })
    fileName: string;
    @Column("varchar", {
        nullable: true,
        name: "file_path",
    })
    filePath: string;

    @Column("boolean", {
        nullable: true,
        name: "is_uploaded",
        default: false
    })
    isUploaded: boolean;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;
    @Column({
        type: 'enum',
        enum: DocumentType,
        nullable: false,
        name: 'document_type',
        default: DocumentType.POSTSAILING
      })
      documentType: DocumentType;
    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50,
        default:"Admin"
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;


    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;


}